import type { SanitySlug } from '~/types'

export const createTitle = (slug: string) => {
  const words = slug.split('-')

  for (let i = 0; i < words.length; i++) {
    const word = words[i]
    words[i] = word.charAt(0).toUpperCase() + word.slice(1)
  }

  return words.join(' ')
}

export const createBreadcrumbs = (
  path: string
): { path: string; name: string }[] => {
  const links = []
  const breadcrumbs = path.split('/')

  for (let i = 0, l = breadcrumbs.length; i < l; i++) {
    const path = breadcrumbs.slice(0, i + 1).join('/')

    const item = {
      path: path ? path : '/',
      name: path ? createTitle(breadcrumbs[i]) : 'Home',
    }

    links.push(item)
  }

  return links
}

export const formatCategoryBreadcrumb = ({
  title,
  type,
  slug,
  parent,
}: {
  title: string
  type: string
  slug: string
  parent?: { slug: { current: string }; title: string }
}) => {
  return parent
    ? [
        { name: parent.title, path: `/${type}/c/${parent.slug.current}` },
        {
          name: title,
          path: `/${type}/c/${slug}`,
        },
      ]
    : [
        {
          name: title,
          path: `/${type}/c/${slug}`,
        },
      ]
}

interface BlogSlugProps {
  slug?: SanitySlug
  slugCategory?: {
    slug: SanitySlug
  }
}

export const createBlogSlug = ({ slug, slugCategory }: BlogSlugProps) => {
  const slugs = ['/blog']

  if (slugCategory?.slug?.current) {
    slugs.push(slugCategory?.slug?.current)
  }

  if (slug?.current) {
    slugs.push(slug?.current)
  }

  return slugs.join('/')
}

export const getOriginFromRequest = (
  request: Request,
  fallback?: string
): string => {
  const origin = request.headers.get('origin') || request.headers.get('referer')

  if (origin) {
    const url = new URL(origin)

    return `${url.protocol}//${url.host}`
  }

  if (fallback) {
    return fallback
  }

  return ''
}
